export default {
    campaignBlock: null,

	init: function(utils, Popin) {
        this.campaignBlock = document.querySelectorAll('.js-campaign');

        if (this.campaignBlock) {
            this.initCampaignClick();
            this.initCampaignObserver();
        }

        body.addEventListener('campaign:updated', () => {
            this.campaignBlock = document.querySelectorAll('.js-campaign');
            if (this.campaignBlock) {
                this.initCampaignClick();
                this.initCampaignObserver();
            }
        })

        //const popinEl = document.querySelector('.js-popin-newsletter')
        this.bindPopin(Popin, utils);
	},

    initCampaignClick: function(){
        this.campaignBlock.forEach(item => {
            // We keep classic 'click' event for a wider support en browsers
            item.addEventListener('click', e => {
                const eventCampaign = e.currentTarget;
                this.ajaxSubmitTracking('click', eventCampaign);
            });

            // This is for the middle button on the mouse
            item.addEventListener('mouseup', e => {
                if (e.button === 1) {
                    const eventCampaign = e.currentTarget;
                    this.ajaxSubmitTracking('click', eventCampaign);
                }
            });
        });
    },

    initCampaignObserver: function(){
        this.campaignBlock.forEach(item => {
            // Maybe useless as we disconnect observer after first view
            // But it's a try to fix the multi view issue on algolia pages (not really working)
            // because algolia renders twice each times, so it can increment twice the view counter
            if( item.classList.contains('--has-observer') ) {
                return;
            }
            item.classList.add('--has-observer');

            // Create an intersection observer to track when element becomes visible
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.ajaxSubmitTracking('view', entry.target);

                        // Stop observing after first view
                        observer.disconnect();
                    }
                });
            }, {
                threshold: 1 // Element is considered viewed when 100% visible
            });

            // Start observing views
            observer.observe(item);
        });
    },

    bindPopin: function(Popin, utils){
        const popinEl = document.querySelector('.js-popin-campaign')
        const popinAlreadyShown = utils.getCookie('campaign_hp_splash_screen');

        if (popinEl && popinAlreadyShown !== 'already_shown') {
            const popinInstance = new Popin(popinEl, {
                openBtnCSSSelector: '.js-popin-campaign-open',
                closeBtnCSSSelector: '.js-popin-campaign-close',
                popinBackCSSSelector: '.js-popin-campaign-back',
                popinContentCSSSelector: '.js-popin-campaign-content'
            })
            popinInstance.open();

            // Only display this every 6 hours
            // 0.25/day
            utils.setCookie('campaign_hp_splash_screen', 'already_shown', 0.25);

            setTimeout(() => {
                popinInstance.close();
            }, 5000);
        }
    },

    ajaxSubmitTracking: function(tracking_type, campaignEl) {
        //const campaign_id = campaignEl.getAttribute('data-campaign-id');
        const campaign_location_id = campaignEl.getAttribute('data-campaign-location-id');
        const click_counter_key = campaignEl.getAttribute('data-click-counter-key');
        const view_counter_key = campaignEl.getAttribute('data-view-counter-key');

        const form_data = new FormData();
        form_data.append('action', 'campaign_front_update_tracking');
        form_data.append('tracking_type', tracking_type);
        //form_data.append('campaign_id', campaign_id);
        form_data.append('campaign_location_id', campaign_location_id);
        form_data.append('click_counter_key', click_counter_key);
        form_data.append('view_counter_key', view_counter_key);

        $.ajax({
            url: wordpress_vars.ajax_url,
            type: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function(){
            },
            complete: () => {
            }
        })
        .done(response => {
            if (!response.success) {
                console.error("ajax response success false", response)
            } else {
                console.log("campaign increment", response)
            }
        })
        .fail(() => {
            console.error("ajax failed");
        })
    },
}